export default __webpack_public_path__ + "static/FLB-75a0f6b52157a348a7eeedfdb828c120.png";